<template>
  <div class="odontology-panel col-md-12">

    <!-- O odontograma ocupa a largura toda: nao cabe na coluna estreita
         em que os campos de texto do prontuario sao renderizados. -->
    <div class="card mb-4" v-if="odontogramAttributes.length">
      <div class="card-body pt-4">
        <InputAttendance v-for="attribute in odontogramAttributes"
                         :key="attribute.id_medrec_attr"
                         :attribute="attribute"
                         :schedule="schedule"
                         :disabled="disabled"
                         @onChange="onAttributeChange"/>
      </div>
    </div>

    <div class="card mb-4" v-if="planAttributes.length">
      <div class="card-header min-h-45px">
        <h5 class="card-title mb-0 fs-6">Plano de tratamento e índices</h5>
      </div>
      <div class="card-body pt-4">
        <InputAttendance v-for="attribute in planAttributes"
                         :key="attribute.id_medrec_attr"
                         :attribute="attribute"
                         :schedule="schedule"
                         :disabled="disabled"
                         @onChange="onAttributeChange"/>
      </div>
    </div>

    <div class="card" v-if="regularAttributes.length">
      <div class="card-header min-h-45px">
        <h5 class="card-title mb-0 fs-6">Registro clínico</h5>
      </div>
      <div class="card-body pt-4">
        <InputAttendance v-for="attribute in regularAttributes"
                         :key="attribute.id_medrec_attr"
                         :attribute="attribute"
                         :schedule="schedule"
                         :disabled="disabled"
                         @onChange="onAttributeChange"/>
      </div>
    </div>

  </div>
</template>

<script>
import InputAttendance from './Input';

const PLAN_TYPES = ['grid', 'structured_list'];

export default {
  name: 'OdontologyPanel',
  components: { InputAttendance },
  emits: ['onChange'],
  props: {
    attributes: { type: Array, default: () => [] },
    schedule: { type: Object, default: null },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    odontogramAttributes() {
      return this.attributes.filter((attribute) => attribute.type === 'odontogram');
    },
    planAttributes() {
      return this.attributes.filter((attribute) => PLAN_TYPES.includes(attribute.type));
    },
    regularAttributes() {
      return this.attributes.filter(
        (attribute) => attribute.type !== 'odontogram' && !PLAN_TYPES.includes(attribute.type),
      );
    },
  },
  methods: {
    onAttributeChange(attribute) {
      this.$emit('onChange', attribute);
    },
  },
};
</script>
